module.exports = __webpack_public_path__ + "img/logoname.c73c5cfa.png";